import { Injectable } from '@angular/core';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { DialogUnpublishSiteComponent } from '@app/modules/direct/dialogs/dialog-unpublish-site/dialog-unpublish-site.component';
import { DirectService, SiteCreateResponse, SitePublishStatuses } from '@app/modules/direct/services/direct.service';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DirectEditService {
  SitePublishStatuses = SitePublishStatuses;
  site$ = new BehaviorSubject<SiteCreateResponse | undefined>(undefined);
  publishing = false;
  isPublished = false;
  error = false;

  constructor(
    private readonly direct: DirectService,
    private readonly dialog: MatLegacyDialog
  ) {
    this.site$.subscribe((site) => {
      if (!site) {
        this.isPublished = false;
        return;
      }

      this.isPublished = site.publish_status === this.SitePublishStatuses.Published;
    });
  }

  get site() {
    return this.site$.value;
  }

  getSite(siteId: string) {
    this.direct.getSite(siteId).subscribe(
      (res) => {
        if (!res) {
          this.error = true;
          return;
        }

        this.setSite(res);
        this.error = false;
      },
      () => (this.error = true)
    );
  }

  setSite(site: Partial<SiteCreateResponse>) {
    this.site$.next({ ...this.site$.value, ...site });
  }

  clean() {
    this.site$.next(undefined);
  }

  publishSite() {
    this.publishing = true;
    this.direct.publishSite(this.site.id).subscribe(
      () => {
        this.publishing = false;
        this.setSite({
          publish_status: this.SitePublishStatuses.Published,
        });
      },
      () => {
        this.publishing = false;
      }
    );
  }

  unpublishSite() {
    const dialogRef = this.dialog.open(DialogUnpublishSiteComponent, {
      width: '720px',
      data: this.site,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.setSite({
          publish_status: this.SitePublishStatuses.NotPublishedYet,
        });
      }
    });
  }

  openPreview() {
    window.open(this.site.preview_url);
  }

  openSite() {
    const url =
      `https://` +
      (this.site.domains?.custom_domain || `${this.site.domains.subdomain}.${this.site.domains.hospitable_domain}`);

    window.open(url);
  }
}
